import React, { useState } from 'react';
import { InputLabel, MenuItem, FormControl, Select, Box, OutlinedInput, TextField } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

export default function MaterialSelect({ title, name, onChange, value, error = false, disabled = false, options = [], style = {}, className }) {
  return (
    <FormControl style={style} className={className} variant="outlined" fullWidth>
      <TextField label={title} select disabled={disabled} name={name} variant="outlined" onChange={onChange} value={value} error={error}>
        <MenuItem fontStyle="italic" value="">
          <Box fontStyle="italic">
            <FormattedMessage id="position.none" description="None" />
          </Box>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.name}
          </MenuItem>
        ))}
      </TextField>
    </FormControl>
  );
}
